import { Component, OnInit } from '@angular/core';
import { COMPANY_NAME } from 'src/app/shared/constants/misc';
import { LinkListItem, SvHorizontalDirection } from 'sv-chemistry-ng-lib';
import { environment } from 'src/environments/environment';
import { UserInfoService } from '../../services/user-info.service';

@Component({
  selector: 'sv-header',
  templateUrl: './sv-header.component.html',
  styleUrls: ['./sv-header.component.scss']
})
export class SvHeaderComponent implements OnInit {
  companyName = COMPANY_NAME;

  constructor(private _userService: UserInfoService) { }


  userName: string = "Problem no user found";
  homeUrl: string = environment.svConnectUrl;
  helpUrl: string = environment.helpUrl;

  utilityNavItems: LinkListItem[] = [
    {
      href: environment.svConnectUrl,
      name: "SVConnect Portal",
      isRouterLink: false
    },
    {
      href: environment.helpUrl,
      name: "Help",
      isRouterLink: false,
      isNewWindow: true
    },
    {
      href: "app/logout",
      name: "Logout",
      isRouterLink: true
    }
  ];

  utilityNavPosition: SvHorizontalDirection = SvHorizontalDirection.Right;

  ngOnInit() {
    let myUser;
      myUser = this._userService.getCurrentUser();
      if(myUser.firstName && myUser.firstName != null && myUser.lastName && myUser.lastName != null) {
        this.userName = myUser.firstName + " " + myUser.lastName;
      } else {
        this.userName = myUser.userId;
      }
  }

  testLinkClick() : void {
    console.log("testing link click");
  }

}
